import { render, staticRenderFns } from "./DogStandingFront.vue?vue&type=template&id=7a722d15&"
import script from "./DogStandingFront.vue?vue&type=script&lang=js&"
export * from "./DogStandingFront.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a722d15')) {
      api.createRecord('7a722d15', component.options)
    } else {
      api.reload('7a722d15', component.options)
    }
    module.hot.accept("./DogStandingFront.vue?vue&type=template&id=7a722d15&", function () {
      api.rerender('7a722d15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/core/Components/Common/Illustrations/DogStandingFront.vue"
export default component.exports